import * as React from 'react';
import { CouponTabsType as RightColumnTicketWrapperAreaTabsType } from 'eTip--common';
import { observer } from 'mobx-react';
import { translationForMts } from 'easit--localization';

export interface ITicketWrapperTabsProps {
    selectedTab: RightColumnTicketWrapperAreaTabsType;
    itemCounts: Map<RightColumnTicketWrapperAreaTabsType, number>; //id is in fact of RightColumnTicketWrapperAreaTabsType

    onTabChange: (tabIndex: RightColumnTicketWrapperAreaTabsType) => void;
}

export const TicketWrapperTabs: React.FC<ITicketWrapperTabsProps> = observer((props: ITicketWrapperTabsProps) => { //TODO do we need observer here?
    return (
        <div className="ticket-main-tabs">
            <div className={`tab ${props.selectedTab === RightColumnTicketWrapperAreaTabsType.Ticket ? 'selected' : ''}`}
                onClick={() => { props.onTabChange(RightColumnTicketWrapperAreaTabsType.Ticket) }}
            >
                <div className="tab-text">{translationForMts().ticket_TicketTabLabel}</div>
            </div>

            <div className={`tab last ${props.selectedTab === RightColumnTicketWrapperAreaTabsType.CashOut ? 'selected' : ''}`}
                onClick={() => { props.onTabChange(RightColumnTicketWrapperAreaTabsType.CashOut) }}
            >
                <div className="tab-text text-uppercase">
                    {translationForMts().ticket_CashoutTab} {props.itemCounts.has(RightColumnTicketWrapperAreaTabsType.CashOut) && "(" + props.itemCounts.get(RightColumnTicketWrapperAreaTabsType.CashOut) + ")"}
                </div>
            </div>
        </div>
    )

});